module.exports = __webpack_public_path__ + "static/media/Group69.5a2b2acb.svg";